import React, { useEffect } from "react";
// import { Outlet } from 'react-router';
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
// import SideBar from "./SideBar";
import NavMenu from "./NavMenu";
import { fetchDepartmentCapability } from "../../features/departmentRoutingSlice";

const Layout = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.root.login.loginDemo?.id);
  const vesselId = useSelector(
    (state) => state.root.common.vessel_detailByID?.id,
  );

  useEffect(() => {
    if (userId) {
      dispatch(
        fetchDepartmentCapability(
          vesselId == null ? {} : { vessel_id: vesselId },
        ),
      );
    }
  }, [dispatch, userId, vesselId]);

  return (
    <>
      <NavMenu />
      <>
        {/* <SideBar /> */}
        <div className="mainContent">
          <Container fluid>
            <Outlet />
          </Container>
        </div>
      </>
    </>
  );
};

export default Layout;
